import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import i18n from 'i18n';
import { get } from 'lodash';
import { GenericFormFields } from '../interfaces';

type Props = GenericFormFields;

const BankSelector: React.FC<Props> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
  // data, esse data antes vinha de um connect
}) => {
  return (
    <Autocomplete
      options={[]}
      value={
        fields
          ? get(fields, item.stateKey, null)
          : get(values, item.stateKey, null)
      }
      getOptionLabel={option => `${option.bankNumber} - ${option.name}`}
      onChange={(e, newValue) => {
        if (setFieldValue) setFieldValue(item.stateKey, newValue);
        if (changeField)
          changeField({
            key: item.stateKey,
            value: newValue,
          });
      }}
      renderInput={params => (
        <TextField
          name={item.stateKey}
          helperText={
            get(errors, item.stateKey, null) || get(errors, item.error, null)
          }
          error={
            !!get(errors, item.stateKey, null) ||
            !!get(errors, item.error, null)
          }
          {...params}
          label={i18n.t('SELECT_BANK_KEY')}
          variant="outlined"
          fullWidth
        />
      )}
    />
  );
};

export default BankSelector;
